// src/i18n.js

// اللغة الافتراضية في الواجهة الأمامية
export const DEFAULT_LANG = "en";

export const translations = {
  en: {
    // ============================
    // General
    // ============================
    app_name: "Mousa Group",
    save: "Save",
    cancel: "Cancel",
    edit: "Edit",
    delete: "Delete",
    add_new: "Add New",
    actions: "Actions",
    no_records: "No records found",
    server_error: "Server connection failed.",
    view: "View",

    // ============================
    // Auth / Admin
    // ============================
    admin_panel: "Admin Panel",
    login: "Login",
    login_title: "Admin Login",
    login_error: "Invalid email or password.",
    logout: "Logout",
    welcome_admin: "Welcome, admin",
    customer: "Customer",

    // ============================
    // Navbar
    // ============================
    nav_home: "Home",
    nav_shop: "Shop",
    nav_offers: "Offers",
    nav_favorites: "Favorites",
    nav_blog: "Blog",
    nav_cart: "Cart",
    nav_my_account: "My Account",
    nav_my_orders: "My Orders",
    nav_hello_user: "Hello, ",
    nav_logout: "Logout",
    nav_admin_panel: "Admin Panel",
    nav_login: "Login",
    nav_signup: "Sign Up",
    nav_lang_toggle: "AR",

    // ============================
    // Cart
    // ============================
    cart_title: "Shopping Cart",
    cart_empty: "Your cart is empty",
    cart_loading: "Loading cart...",
    cart_product: "Product",
    cart_price: "Price",
    cart_qty: "Qty",
    cart_total: "Total",
    cart_remove: "Remove",
    cart_checkout: "Checkout",
    cart_item_removed: "Item removed",
    cart_update_ok: "Quantity updated",
    cart_update_fail: "Update failed",
    cart_load_fail: "Failed to load cart.",
    cart_invalid_item: "Invalid cart item id",
    cart_go_shop: "Go to shop",
    cart_confirm_remove: "Remove this item?",
    cart_remove_fail: "Failed to remove item.",
    cart_summary: "Cart summary",
    cart_empty2: "Cart is empty.",

    // ============================
    // Checkout
    // ============================
    checkout: "Checkout",
    checkout_title: "Checkout",
    loading_cart: "Loading cart...",
    full_name: "Full name",
    email: "Email",
    phone: "Phone",
    full_address: "Full address",
    total: "Total",
    place_order: "Place order",
    submitting: "Submitting...",
    order_success: "Order created. ID: ",
    order_failed: "Failed to create order.",

    // ============================
    // Orders
    // ============================
    orders: "Orders",
    orders_title: "My Orders",
    orders_id: "ID",
    orders_total: "Total",
    orders_status: "Status",

    // ============================
    // Dashboard main
    // ============================
    dashboard: "Dashboard",
    products: "Products",
    categories: "Categories",
    users: "Users",
    total_products: "Products",
    total_categories: "Categories",
    total_orders: "Orders",
    total_users: "Users",
    statistics: "Statistics",

    // ============================
    // Visitors
    // ============================
    visitors_stats: "Visitors Statistics",
    total_visits: "Total Visits",
    human_visitors: "Human visitors",
    search_bots: "Search bots",

    // ============================
    // Products / Variants
    // ============================
    price: "Price",
    sale_price: "Sale price",
    product_image: "Product image",
    variants: "Variants",
    image: "Image",
    status: "Status",
    views: "Views",
    created_at: "Created at",

    // ============================
    // Attributes
    // ============================
    attributes: "Attributes",
    attributes_subtitle:
      "Manage product attributes (color, size, EU size, etc.) and use them in variants.",
    name_ar: "Name (Arabic)",
    name_en: "Name (English)",
    slug: "Slug",
    slug_auto_hint: "Leave empty to auto-generate.",
    attribute_saving: "Saving attribute...",
    attribute_deleting: "Deleting attribute...",
    confirm_delete_attribute: "Delete attribute?",

    // ============================
    // Blog Categories
    // ============================
    blog_categories: "Blog Categories",
    blog_cat_subtitle: "Manage blog categories and organize articles.",
    category_name_required: "Category name is required.",
    category_saved: "Category saved successfully...",
    category_deleted: "Category deleted...",
    confirm_delete_category: "Are you sure you want to delete this category?",

    // ============================
    // Blog Posts
    // ============================
    blog_posts: "Blog Posts",
    blog_posts_subtitle:
      "Manage blog posts, create, edit and publish articles.",
    title_ar: "Title (Arabic)",
    title_en: "Title (English)",
    content_ar: "Content (Arabic)",
    content_en: "Content (English)",
    all_statuses: "All statuses",
    all_categories: "All categories",
    no_category: "No category",
    search_by_title: "Search by title",
    filter: "Filter",
    no_image: "No image",
    post_saved_success: "Post saved successfully.",
    post_deleted: "Post deleted.",
    confirm_delete_post: "Delete this post?",

    // ============================
    // Blog Frontend
    // ============================
    no_posts: "No blog posts yet.",
    back_to_blog: "Back to blog",
    load_error: "Unable to load post.",
    post_not_found: "Post not found.",
    read_time: " min read",
    error: "Error",
    continue_reading: "Continue reading",
    article_actions: "Article actions",
    share_article: "Share this article",
    copied: "Copied!",
    copy_link: "Copy link",
    read_more_articles: "Read more articles",

    // ============================
    // Notifications
    // ============================
    notifications: "Notifications",
    mark_all_read: "Mark all as read",
    notifications_subheader:
      "Stay up to date with the latest updates and news regarding your orders, shipments, and exclusive offers. We make sure to keep you informed about everything that matters.",
    no_notifications: "No notifications",
    no_notifications_desc:
      "Your new notifications will appear here as soon as they arrive. Follow your orders and our exclusive offers.",
    view_details: "View details",
    mark_read: "Mark as read",
    dismiss: "Dismiss",
    load_more: "Load More",
    all_caught_up: "You're all caught up",
    time_just_now: "Just now",
    type_order: "Order",
    type_shipment: "Shipment",
    type_promo: "Offer",
    type_info: "Info",
    type_warning: "Alert",
    type_system: "System",
    type_notification: "Notification",

    // Notification actions
    loading: "Loading...",
    see_all: "See all",
    dismiss_all: "Dismiss all",
    dismissing: "Dismissing...",
    no_notifications_filter: "No notifications in this category",
    try_all_tab: "Try viewing All to see all notifications.",

    // Notification dynamic patterns — single source of truth
    notif_new_order: "New order #{order}",
    notif_payment_received: "Payment received for order #{order}",
    notif_invoice_ready: "Invoice {invoice} is ready",
    notif_shipping_update: "Shipping update for order #{order}",
    notif_order_shipped: "Order #{order} shipped",
    notif_order_delivered: "Order #{order} delivered",
    notif_order_created: "Your order #{order} has been created successfully",
    notif_shipping_info: "Shipping: {method} (ETA: {eta})",
    notif_payment_completed: "Your payment of ${amount} via {method} was completed successfully",
    notif_payment_received_amount: "Payment of ${amount} received",
    notif_invoice_download: "Invoice {invoice} is now available for download",
    notif_invoice_account: "You can download your invoice from your account",

    // System / Digital / User / Email notifications
    notif_digital_ready: "Your digital items are ready",
    notif_download_ready: "Your download is ready",
    notif_download_account: "You can now download your files from your account",
    notif_download_link_text: "Click here to access your downloads",
    notif_welcome: "Welcome to Mousa Group",
    notif_profile_update: "Your profile has been updated",
    notif_email_verify: "Please verify your email address",
    notif_email_verified: "Your email has been verified",
    notif_password_reset: "Password reset link sent",
    notif_maintenance: "System maintenance scheduled",
    notif_system_update: "System update available",
    notif_new_login: "New login detected",
    notif_password_changed: "Your password has been changed",

    // ============================
    // Tools / Settings
    // ============================
    tools: "Tools",
    db_tools: "DB Tools",
    upload_tools: "Upload Folders",
    error_log_tools: "Error Log",
    fix_upload_permissions: "Fix upload folders",
    test_db_connection: "Test DB Connection",
    clear_cache: "Clear Cache",
    clear_error_log: "Clear error_log",
    gallery: "Gallery",
    settings: "Settings",
    site_settings: "Site Settings",
    visit_website: "Visit Website",

    // ============================
    // Processing / Redirect
    // ============================
    processing: "Processing...",
    redirect_not_auto: "If you are not redirected automatically,",
    click_here: "click here",
  },

  ar: {
    // ============================
    // عام
    // ============================
    app_name: "مجموعة موسى",
    save: "حفظ",
    cancel: "إلغاء",
    edit: "تعديل",
    delete: "حذف",
    add_new: "إضافة جديد",
    actions: "الخيارات",
    no_records: "لا توجد بيانات",
    server_error: "فشل الاتصال بالسيرفر.",
    view: "عرض",

    // ============================
    // تسجيل دخول / إدارة
    // ============================
    admin_panel: "لوحة التحكم",
    login: "تسجيل الدخول",
    login_title: "دخول الإدارة",
    login_error: "البريد الإلكتروني أو كلمة المرور غير صحيحة.",
    logout: "تسجيل الخروج",
    welcome_admin: "مرحباً أيها المدير",
    customer: "العميل",

    // ============================
    // الهيدر / Navbar
    // ============================
    nav_home: "الرئيسية",
    nav_shop: "المتجر",
    nav_offers: "العروض",
    nav_favorites: "المفضلة",
    nav_blog: "المدونة",
    nav_cart: "السلة",
    nav_my_account: "حسابي",
    nav_my_orders: "طلباتي",
    nav_hello_user: "مرحباً، ",
    nav_logout: "تسجيل الخروج",
    nav_admin_panel: "لوحة التحكم",
    nav_login: "تسجيل الدخول",
    nav_signup: "إنشاء حساب",
    nav_lang_toggle: "EN",

    // ============================
    // السلة
    // ============================
    cart_title: "سلة المشتريات",
    cart_empty: "سلة المشتريات فارغة",
    cart_loading: "جارٍ تحميل السلة...",
    cart_product: "المنتج",
    cart_price: "السعر",
    cart_qty: "الكمية",
    cart_total: "الإجمالي",
    cart_remove: "إزالة",
    cart_checkout: "إتمام الطلب",
    cart_item_removed: "تم حذف المنتج من السلة",
    cart_update_ok: "تم تحديث الكمية",
    cart_update_fail: "فشل تحديث الكمية",
    cart_load_fail: "فشل تحميل السلة.",
    cart_invalid_item: "عنصر سلة غير صالح",
    cart_go_shop: "الذهاب إلى المتجر",
    cart_confirm_remove: "هل أنت متأكد من حذف هذا المنتج؟",
    cart_remove_fail: "فشل حذف المنتج.",
    cart_summary: "ملخص السلة",
    cart_empty2: "السلة فارغة.",

    // ============================
    // إتمام الطلب
    // ============================
    checkout: "إتمام الطلب",
    checkout_title: "إتمام الطلب",
    loading_cart: "جارٍ تحميل السلة...",
    full_name: "الاسم الكامل",
    email: "البريد الإلكتروني",
    phone: "رقم الهاتف",
    full_address: "العنوان الكامل",
    total: "الإجمالي",
    place_order: "إرسال الطلب",
    submitting: "جارٍ الإرسال...",
    order_success: "تم إنشاء الطلب. رقم الطلب: ",
    order_failed: "فشل إنشاء الطلب.",

    // ============================
    // الطلبات
    // ============================
    orders: "الطلبات",
    orders_title: "طلباتي",
    orders_id: "رقم",
    orders_total: "الإجمالي",
    orders_status: "الحالة",

    // ============================
    // لوحة التحكم الرئيسية
    // ============================
    dashboard: "لوحة التحكم الرئيسية",
    products: "المنتجات",
    categories: "التصنيفات",
    users: "المستخدمين",
    total_products: "عدد المنتجات",
    total_categories: "عدد التصنيفات",
    total_orders: "عدد الطلبات",
    total_users: "عدد المستخدمين",
    statistics: "إحصائيات",

    // ============================
    // الزوار
    // ============================
    visitors_stats: "إحصائيات الزوار",
    total_visits: "إجمالي الزيارات",
    human_visitors: "الزوار البشريون",
    search_bots: "زواحف محركات البحث",

    // ============================
    // المنتجات / الخيارات
    // ============================
    price: "السعر",
    sale_price: "سعر الخصم",
    product_image: "صورة المنتج",
    variants: "الخيارات",
    image: "الصورة",
    status: "الحالة",
    views: "المشاهدات",
    created_at: "تاريخ الإنشاء",

    // ============================
    // الخصائص (Attributes)
    // ============================
    attributes: "الخصائص",
    attributes_subtitle:
      "إدارة خصائص المنتجات (مثل اللون، المقاس، المقاس الأوروبي...) واستخدامها داخل الخصائص (Variants).",
    name_ar: "الاسم (عربي)",
    name_en: "الاسم (إنجليزي)",
    slug: "الرابط المختصر",
    slug_auto_hint: "اتركه فارغًا ليتم توليده تلقائياً.",
    attribute_saving: "جارٍ حفظ الخاصية...",
    attribute_deleting: "جارٍ حذف الخاصية...",
    confirm_delete_attribute: "هل تريد حذف هذه الخاصية؟",

    // ============================
    // تصنيفات المدونة
    // ============================
    blog_categories: "تصنيفات المدونة",
    blog_cat_subtitle: "إدارة تصنيفات المدونة وتنظيم المقالات.",
    category_name_required: "اسم التصنيف مطلوب.",
    category_saved: "تم حفظ التصنيف...",
    category_deleted: "تم حذف التصنيف...",
    confirm_delete_category:
      "هل أنت متأكد أنك تريد حذف هذا التصنيف؟",

    // ============================
    // مقالات المدونة
    // ============================
    blog_posts: "مقالات المدونة",
    blog_posts_subtitle:
      "إدارة مقالات المدونة، إضافة وتعديل ونشر المقالات.",
    title_ar: "العنوان (عربي)",
    title_en: "العنوان (إنجليزي)",
    content_ar: "المحتوى (عربي)",
    content_en: "المحتوى (إنجليزي)",
    all_statuses: "كل الحالات",
    all_categories: "كل التصنيفات",
    no_category: "بدون تصنيف",
    search_by_title: "بحث بالعنوان",
    filter: "تصفية",
    no_image: "لا توجد صورة",
    post_saved_success: "تم حفظ المقال بنجاح.",
    post_deleted: "تم حذف المقال.",
    confirm_delete_post: "حذف هذا المقال؟",

    // ============================
    // واجهة المدونة
    // ============================
    no_posts: "لا توجد مقالات حالياً.",
    back_to_blog: "العودة للمدونة",
    load_error: "تعذّر تحميل المقال.",
    post_not_found: "المقال غير موجود.",
    read_time: " دقائق قراءة",
    error: "خطأ",
    continue_reading: "أكمل القراءة",
    article_actions: "إجراءات المقال",
    share_article: "شارك المقال",
    copied: "تم النسخ",
    copy_link: "نسخ الرابط",
    read_more_articles: "اقرأ المزيد من المقالات",

    // ============================
    // الإشعارات
    // ============================
    notifications: "الإشعارات",
    mark_all_read: "تحديد الكل كمقروء",
    notifications_subheader:
      "تابع آخر التحديثات والأخبار المتعلقة بطلباتك وشحناتك وعروضنا الحصرية. نحرص على إبقائك على اطلاع دائم بكل ما يهمك.",
    no_notifications: "لا توجد إشعارات",
    no_notifications_desc:
      "ستظهر إشعاراتك الجديدة هنا فور وصولها. تابع طلباتك وعروضنا الحصرية.",
    view_details: "عرض التفاصيل",
    mark_read: "تحديد كمقروء",
    dismiss: "تجاهل",
    load_more: "تحميل المزيد",
    all_caught_up: "أنت على اطلاع بكل شيء",
    time_just_now: "منذ قليل",
    type_order: "طلب",
    type_shipment: "شحنة",
    type_promo: "عرض",
    type_info: "معلومة",
    type_warning: "تنبيه",
    type_system: "نظام",
    type_notification: "إشعار",

    // Notification actions
    loading: "جارِ التحميل...",
    see_all: "عرض الكل",
    dismiss_all: "تجاهل الكل",
    dismissing: "جارٍ التجاهل...",
    no_notifications_filter: "لا توجد إشعارات في هذا التصنيف",
    try_all_tab: "جرّب عرض الكل لرؤية جميع الإشعارات.",

    // Notification dynamic patterns — single source of truth
    notif_new_order: "طلب جديد #{order}",
    notif_payment_received: "تم استلام الدفع للطلب #{order}",
    notif_invoice_ready: "الفاتورة {invoice} جاهزة",
    notif_shipping_update: "تحديث الشحن للطلب #{order}",
    notif_order_shipped: "تم شحن الطلب #{order}",
    notif_order_delivered: "تم تسليم الطلب #{order}",
    notif_order_created: "تم إنشاء طلبك #{order} بنجاح",
    notif_shipping_info: "الشحن: {method} (الوقت المتوقع: {eta})",
    notif_payment_completed: "تم إتمام دفعتك بقيمة ${amount} عبر {method} بنجاح",
    notif_payment_received_amount: "تم استلام دفعة بقيمة ${amount}",
    notif_invoice_download: "الفاتورة {invoice} متاحة للتحميل الآن",
    notif_invoice_account: "يمكنك تحميل فاتورتك من حسابك",

    // System / Digital / User / Email notifications
    notif_digital_ready: "عناصرك الرقمية جاهزة",
    notif_download_ready: "تحميلك جاهز",
    notif_download_account: "يمكنك الآن تحميل ملفاتك من حسابك",
    notif_download_link_text: "اضغط هنا للوصول إلى التحميلات",
    notif_welcome: "مرحباً بك في مجموعة موسى",
    notif_profile_update: "تم تحديث ملفك الشخصي",
    notif_email_verify: "يرجى التحقق من عنوان بريدك الإلكتروني",
    notif_email_verified: "تم التحقق من بريدك الإلكتروني",
    notif_password_reset: "تم إرسال رابط إعادة تعيين كلمة المرور",
    notif_maintenance: "صيانة النظام مجدولة",
    notif_system_update: "تحديث النظام متاح",
    notif_new_login: "تم اكتشاف تسجيل دخول جديد",
    notif_password_changed: "تم تغيير كلمة المرور الخاصة بك",

    // ============================
    // أدوات / إعدادات
    // ============================
    tools: "أدوات",
    db_tools: "أدوات قاعدة البيانات",
    upload_tools: "مجلدات الرفع",
    error_log_tools: "سجل الأخطاء",
    fix_upload_permissions: "إصلاح مجلدات الرفع",
    test_db_connection: "اختبار اتصال قاعدة البيانات",
    clear_cache: "تحديث الكاش",
    clear_error_log: "تنظيف سجل الأخطاء",
    gallery: "المعرض",
    settings: "الإعدادات",
    site_settings: "إعدادات الموقع",
    visit_website: "زيارة الموقع",

    // ============================
    // معالجة / تحويل
    // ============================
    processing: "جارٍ المعالجة...",
    redirect_not_auto: "إذا لم يتم تحويلك تلقائيًا،",
    click_here: "اضغط هنا",
  },
};

// ================================
//   Translation helper
// ================================
export function t(lang, key, defaultText = null) {
  const value = translations[lang]?.[key];

  if (typeof value === "string" && value.length > 0) {
    return value;
  }

  // نفس فكرة PHP: t($key, $default)
  if (defaultText !== null && defaultText !== undefined && defaultText !== "") {
    return defaultText;
  }

  // آخر حل: نرجّع المفتاح نفسه
  return key;
}

// مفيد لتحديد اتجاه النص في React
export function getDirection(lang) {
  return lang === "ar" ? "rtl" : "ltr";
}

export default translations;